import React from 'react';
import { IArticle } from '../types';

// eslint-disable-next-line @typescript-eslint/naming-convention
const markirovka_reklami_v_internete: IArticle = {
  title: 'Маркировка рекламы в интернете: обзор ключевых моментов',
  image: '/assets/img/blog/markirovka_reklami_v_internete.jpeg',
  prewievImage: '/assets/img/blog/markirovka_reklami_v_internete-prewiev.jpeg',
  content: [
    {
      text: [
        '1 сентября 2022 года вступили в силу поправки в Закон о рекламе № 347-ФЗ (п.3 ст.1 от 02.07.2021г.), введены требования об обязательной маркировке рекламы в сети Интернет и о необходимости предоставления информации о размещенной рекламе.',
        'Изменения в Законе о рекламе коснулись всех участников рынка: рекламодателей (РД), рекламораспространителей (РР), рекламных агентств (РА), операторов рекламных систем (ОРС). После принятия Закона рынок вступил в «переходную фазу» адаптации к новым правилам.  1 сентября 2023 года были введены штрафы за несоблюдение правил маркировки и порядка передачи отчетности. Это основные нововведения, которые произошли на рынке Интернет-рекламы за последние два года.',
        'В данной статье и осветим ключевые моменты, касающиеся маркировки Интернет-рекламы, дадим определение и разъясним, какие изменения произошли в рамках нового законодательства, опишем процесс передачи данных и расскажем о мерах ответственности за несоблюдение законодательства о маркировке.',
      ],
    },
    {
      subTitle: 'Как маркировать рекламу в Интернете и что такое маркировка?',
      text: [
        'Согласно поправкам к Закону о рекламе с 1 сентября 2022 года ко всем рекламным публикациям в интернете необходимо добавлять:',
        <ul>
          <li>пометку «реклама»</li>
          <li>
            информацию о рекламодателе и/или ссылку на страницу/сайт с
            информацией о рекламодателе.
          </li>
        </ul>,
        'Помимо этого, каждая публикация должна быть промаркирована специальным идентификатором (рекламным маркером / токеном / erid). Идентификатор должен быть включен в кликовую ссылку объявления, либо в меню AdChoice, а при отсутствии такой возможности — в виде пометки внутри рекламного материала или иным способом, в зависимости от формата.',
        <>
          Подробно о маркировке различных форматов креативов мы рассказали в
          статье:{' '}
          <a href="/blog/poryadok_razmeshenia_markera_v_reklame">
            «Порядок размещения маркера (erid: xxxx) в рекламе с примерами»
          </a>
          .
        </>,
        'Маркировка интернет-рекламы – это процесс сопровождения рекламной публикации пометкой «реклама», идентификатором erid и сведениями о рекламодателе.',
        'Генерацией и выдачей идентификаторов erid занимаются операторы рекламных данных (ОРД).',
        'ОРД (оператор рекламных данных) – это электронная площадка, аккредитованная Роскомнадзором и созданная специально для агрегации сведений об интернет-рекламе, генерации рекламных маркеров (erid) и передаче данных в Единый реестр интернет-рекламы (ЕРИР), специально созданной структурой Роскомнадзора.',
        'ОРД является посредником между участником рекламного рынка и ЕРИР. Напрямую взаимодействовать с ЕРИР рекламодатель или любой другой участник рекламной цепочки не может.',
        'Важно помнить, что по факту размещения каждой рекламной публикации необходимо подавать отчётность в ЕРИР через ОРД. В отчётность включаются данные о формате креатива, датах размещения, количестве просмотров и участниках рекламной цепочки. Отчётность подаётся через ОРД в течении 30 дней, следующих за месяцем размещения.',
      ],
    },
    {
      subTitle: 'Что такое «реклама» и что считать рекламой?',
      text: [
        'Следуя определению, реклама – это информация, призванная привлечь внимание к товарам и услугам, и выделить продукт или услугу среди аналогичных предложений. Однако однозначного критерия, что является рекламой, а что нет – не существует, каждый случай требует индивидуального анализа.',
      ],
    },
    {
      subTitle: 'Согласно разъяснениям ФАС России не являются рекламой:',
      text: [
        <ul>
          <li>справочно-аналитические материалы;</li>
          <li>
            научные исследования и рыночные обзоры, которые не преследуют цель
            продвижения товаров;
          </li>
          <li>
            данные в справочно-каталожных изданиях, где представлена
            единообразная информация об организациях или товарах;
          </li>
          <li>
            информация о товарах или услугах на сайте и в социальных сетях
            компании, производителя или продавца, если она служит для
            информирования пользователей о наличии ассортимента и правил
            пользования;
          </li>
          <li>поисковая выдача, каталоги и сайты с объявлениями;</li>
        </ul>,
      ],
    },
    {
      subTitle: 'Ответственность участников рекламной цепочки',
      text: [
        'Все данные о рекламе и об участниках рекламной цепочки должны быть переданы в Единый реестр интернет-рекламы (ЕРИР). В состав передаваемых данных входит: информация об участниках (организации, юридические или физические лица), сопровождающие документы (договоры, акты, приложения), креативы (текст, графика, видео) и статистика показов (отчёты по датам размещения и количеству показов).',
        'Важно помнить, что ответственность за маркировку рекламы несут все участники цепочки, а вот ответственного за передачу данных в ОРД определяют сами стороны по соглашению и прописывают данный пункт в Договоре. Закон не определяет конкретного лица, ответственного за передачу данных.',
        'В соответствии с указаниями Роскомнадзора, обязательства по маркировке рекламы и передаче данных могут быть переданы третьим лицам (например, рекламным агентствам или компаниям, специализирующимся на предоставлении услуг по маркировке рекламы). Однако это не снимет ответственности с участников рекламной цепочки в случае, если маркировка рекламы и передача сведений о рекламе не будет произведена. (Данные критерии установлены постановлением Правительства Российской Федерации от 25 мая 2022 г. N 948).',
      ],
    },
    {
      subTitle: 'Ответственность и штрафы за отсутствие маркировки',
      text: [
        'С 1 сентября 2023 года вступили в силу меры административной ответственности в виде штрафов за несоблюдение правил маркировки, размеры которых варьируются в зависимости от категории нарушения.',
      ],
    },
    {
      subTitle: 'К видам нарушений правил маркировки относятся:',
      text: [
        <ul>
          <li>
            непредоставление информации о рекламе в ЕРИР, а также предоставление
            неполных, недостоверных, неактуальных данных;
          </li>
          <li>
            распространение рекламы без специального идентификатора (erid), либо
            с нарушением норм размещения;
          </li>
          <li>
            отсутствие в рекламной публикации пометки «реклама» и/или указания
            рекламодателя.
          </li>
        </ul>,
      ],
    },
    {
      subTitle: 'Размеры штрафов за несоблюдение правил маркировки:',
      text: [
        <ul>
          <li>Для физических лиц: от 10 000 до 30 000 рублей;</li>
          <li>
            Для должностных лиц и индивидуальных предпринимателей: от 30 000 до
            100 000 рублей;
          </li>
          <li>Для юридических лиц: от 200 000 до 500 000 рублей.</li>
        </ul>,
        'Размеры штрафов для операторов рекламных данных за несоблюдение обязательств при передаче информации в Роскомнадзор:',
        <ul>
          <li>Для должностных лиц: от 100 000 до 200 000 рублей;</li>
          <li>Для юридических лиц: от 300 000 до 700 000 рублей.</li>
        </ul>,
        <>
          Подробно о видах нарушений правил маркировки и ответственности мы
          рассказали в статье:{' '}
          <a href="/blog/otvetstvennost_za_shtrafi">
            «Ответственность и штрафы за отсутствие маркировки рекламы в
            интернете»
          </a>
          .
        </>,
      ],
    },
    {
      subTitle: 'Как начать маркировать рекламу и передавать данные в ОРД?',
      text: [
        'Выше мы осветили ключевые моменты маркировки интернет-рекламы и этих знаний достаточно, чтобы уже приступить к маркировке и начать передавать сведения о рекламе в ЕРИР.',
        'ОРД от SberAds является одним из семи аккредитованных Роскомнадзором оператором рекламных данных, который обеспечивает надежное хранение и оперативную передачу ваших данных в ЕРИР.',
      ],
    },
    {
      subTitle: 'Чтобы стать клиентом, достаточно:',
      text: [
        <ul>
          <li>Зарегистрироваться на сайте;</li>
          <li>Загрузить документы;</li>
          <li>Принять Оферту;</li>
          <li>Приступить к передаче данных.</li>
        </ul>,
        <>
          Перед началом работы, вы можете в тестовом режиме познакомиться с
          функционалом кабинета ОРД и пройти все этапы маркировки в бесплатной
          среде{' '}
          <a href="https://sandbox.ord-lab.ru" target="_blank" rel="noreferrer">
            Sandbox
          </a>
          , без передачи данных в ЕРИР.
        </>,
        'Помимо этого, вам всегда на помощь придёт обширная База знаний и обучающие вебинары, которые проводятся на регулярной основе, а также живая клиентская поддержка, которая оперативно ответит на любые вопросы по работе в Личном кабинете ОРД.',
      ],
    },
  ],
};

export default markirovka_reklami_v_internete;
